/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import { webApi } from "../../lib/WebApi"
import * as localForage from "localforage"
import { clearToken } from "trux"

export const defaultState = {
    currentTeamId: null,
    currentTeam: null,
    divisions: [],
    user: null,
    loading: false,
    loggingInUser: false,
    loggingInTeam: false,
    isUserLoggedIn: null,
    isTeamLoggedIn: null,
    loadedTeam: false,
}

export function init(teamId) {
    return (dispatch, getState) => {
        var nav = getState().common.nav
        if (nav == null) {
            nav = Object.assign({}, defaultState)
        }
        dispatch({
            type: "COMMON_SET",
            value: { currentTeamId: teamId },
            key: "nav",
            defaultValue: defaultState,
        })
        dispatch(
            loadUser((user) => {
                dispatch(loadTeams2(user))
            })
        )
    }
}

export function fromIOS() {
    return {
        type: "COMMON_SET",
        value: { via: "iosapp" },
        key: "nav",
        defaultValue: defaultState,
    }
}

export function logoutUser() {
    return (dispatch) => {
        webApi
            ._post("/webapp/users/self/logout")
            .then((json) => {
                dispatch({
                    type: "COMMON_RESET",
                })
            })
            .catch((err) => console.warn("FAILED to logout user", err))
    }
}

export function loadUser(cb = null) {
    return (dispatch) => {
        dispatch({
            type: "COMMON_SET",
            value: {
                loadingUser: true,
            },
            key: "nav",
            defaultValue: defaultState,
        })

        return webApi
            ._get("/webapp/users/self")
            .then((json) => {
                dispatch({
                    type: "COMMON_SET",
                    value: {
                        user: json,
                        loadingUser: false,
                        isUserLoggedIn: true,
                        loadUserError: null,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })

                if (cb) {
                    cb(json)
                }
            })
            .catch((err) => {
                dispatch({
                    type: "COMMON_SET",
                    value: {
                        user: null,
                        loadingUser: false,
                        isUserLoggedIn: false,
                        loadUserError: err,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })

                if (cb) {
                    cb(null)
                }
            })
    }
}

export function loadTeams2(user) {
    return (dispatch, getState) => {
        console.log("loadTeams2", user)
        let teamId = getState().common.nav.currentTeamId

        // get divisions
        webApi
            ._get("/webapp/users/self/divisions", { sport_type: "any" })
            .then((divisions) => {
                return divisions.map((d) => {
                    d.teams = []
                    d.myTeams = []
                    return d
                })
            })
            // sort divisions
            .then((divisions) => {
                return divisions.sort((a, b) => {
                    return a.title.localeCompare(b.title)
                })
            })
            // get teams for each division
            .then((divisions) => {
                var requests = []
                for (var i in divisions) {
                    var div = divisions[i]
                    requests.push({
                        uri: `/divisions/${div.division_id}/teams`,
                        method: "GET",
                    })
                }

                var params = {
                    requests: JSON.stringify(requests),
                }

                return webApi._post("/webapp/batch", params).then((json) => {
                    for (var i in divisions) {
                        divisions[i].teams = json[i].data
                        divisions[i].myTeams = []
                        if (
                            divisions[i].is_owner === true ||
                            divisions[i].is_owner === 1 ||
                            divisions[i].is_owner === "1"
                        ) {
                            console.log(
                                divisions[i].title,
                                divisions[i].is_owner
                            )
                            divisions[i].myTeams = json[i].data
                        }
                    }
                    divisions.push({
                        is_owner: false,
                        division_id: -1,
                        title: "Other",
                        teams: [],
                        myTeams: [],
                    })
                    return divisions
                })
            })
            // get my teams
            .then((divisions) => {
                return webApi
                    ._get("/webapp/users/self/teams", { sport_type: "any" })
                    .then((teams) => {
                        for (var team of teams) {
                            var matched = false
                            for (var div of divisions) {
                                if (
                                    team.division_ids.includes(div.division_id)
                                ) {
                                    let ft = div.myTeams.find(
                                        (t) => t.team_id === team.team_id
                                    ) // eslint-disable-line no-loop-func
                                    if (!ft) {
                                        div.myTeams.push(team)
                                    }
                                    matched = true
                                }
                            }
                            if (!matched) {
                                divisions[divisions.length - 1].myTeams.push(
                                    team
                                )
                            }
                        }
                        console.log("divisions", divisions)
                        return divisions
                    })
            })
            // get relations / relations teams
            .then((divisions) => {
                if (user) {
                    console.log("loadTeams2 user logged in getting relations")
                    let relationsParams = {
                        relation_type: "parent",
                    }
                    return webApi
                        ._get(
                            `/webapp/users/${user.user_id}/relations`,
                            relationsParams
                        )
                        .then((relationsObj) => {
                            let requests = []
                            let relations = []
                            let relationsKeys = Object.keys(relationsObj)
                            for (var rk of relationsKeys) {
                                let rel = relationsObj[rk]
                                relations.push(rel)
                                requests.push({
                                    uri: `/users/${rel.related_user.user_id}/teams`,
                                    method: "GET",
                                })
                            }

                            var params = {
                                requests: JSON.stringify(requests),
                            }

                            if (relations.length === 0) {
                                return divisions
                            }

                            return webApi
                                ._post("/webapp/batch", params)
                                .then((json) => {
                                    console.log(
                                        "loadTeams2",
                                        "relations",
                                        "teams",
                                        json
                                    )
                                    for (var i in relations) {
                                        let rel = relations[i]
                                        if (json[i].success) {
                                            divisions.push({
                                                is_owner: false,
                                                division_id: -1,
                                                title: `${rel.related_user.first_name}'s Teams`,
                                                teams: json[i].data,
                                                myTeams: json[i].data,
                                            })
                                        }
                                    }
                                    return divisions
                                })
                        })
                } else {
                    console.log(
                        "loadTeams2 user not logged in skipping relations"
                    )
                    return divisions
                }
            })
            // sort & filter teams
            .then((divisions) => {
                console.log("loadTeams2 sort", divisions)
                for (let div of divisions) {
                    div.myTeams.sort((a, b) => {
                        return a.title.localeCompare(b.title)
                    })
                }
                for (let div of divisions) {
                    if (div.division_id <= 0) {
                        // remove duplicates from other and relation's teams
                        div.myTeams = div.myTeams.filter((tm) => {
                            let keep = true
                            for (let d of divisions) {
                                if (d.division_id > 0) {
                                    for (let t of d.myTeams) {
                                        if (t.team_id === tm.team_id) {
                                            keep = false
                                            break
                                        }
                                    }
                                }
                            }
                            return keep
                        })
                    }
                }
                return divisions
            })
            // find current team
            .then((divisions) => {
                var isUserCoach = false
                var curTeam = null
                var curTeamId = getState().common.nav.currentTeamId
                if (teamId && teamId !== "expelliarmus") {
                    localForage.setItem("current_team_id", teamId)
                }
                for (var i in divisions) {
                    var div = divisions[i]
                    for (var t in div.myTeams) {
                        var tm = div.myTeams[t]
                        if (tm.team_id === curTeamId) {
                            curTeam = tm
                        }
                        if (tm.name === curTeamId) {
                            curTeam = tm
                        }
                        if (tm.has_admin_access === true) {
                            isUserCoach = true
                        }
                    }
                }

                divisions = divisions.filter((div) => {
                    return div.myTeams.length > 0
                })

                return {
                    divisions,
                    curTeam,
                    curTeamId,
                    isUserCoach,
                }
            })
            // Login Team / dispatch results
            .then((data) => {
                if (
                    data.curTeam &&
                    data.curTeam.team_id &&
                    data.curTeam.access_password
                ) {
                    // cache last used current team
                    if (data.curTeam.name !== "expelliarmus") {
                        localForage.setItem(
                            "current_team_id",
                            data.curTeam.name
                        )
                    }
                    webApi
                        .login(
                            data.curTeam.team_id,
                            data.curTeam.access_password
                        )
                        .then((success) => {
                            dispatch({
                                type: "COMMON_SET",
                                value: {
                                    currentTeam: data.curTeam,
                                    divisions: data.divisions,
                                    isUserCoach: data.isUserCoach,
                                    divisionsDidLoad: true,
                                    isTeamLoggedIn: true,
                                },
                                key: "nav",
                                defaultValue: defaultState,
                            })
                            dispatch({
                                type: "TeamAuthUpdate",
                                state: {
                                    isLoggedIn: true,
                                    error: null,
                                    teamId: data.curTeam.team_id,
                                    teamName: data.curTeam.name,
                                    team: data.curTeam,
                                    loaded: true,
                                },
                            })
                            dispatch({
                                type: "REV",
                            })
                        })
                        .catch((err) => {
                            dispatch({
                                type: "COMMON_SET",
                                value: {
                                    currentTeam: data.curTeam,
                                    divisions: data.divisions,
                                    isUserCoach: false,
                                    divisionsDidLoad: true,
                                    isTeamLoggedIn: false,
                                    loaded: true,
                                },
                                key: "nav",
                                defaultValue: defaultState,
                            })
                            dispatch({
                                type: "REV",
                            })
                        })
                } else {
                    var values = {
                        divisions: data.divisions,
                        divisionsDidLoad: true,
                        isTeamLoggedIn: false,
                    }
                    if (data.curTeam) {
                        values.currentTeam = data.curTeam
                        values.isUserCoach = false
                    }
                    dispatch({
                        type: "COMMON_SET",
                        value: values,
                        key: "nav",
                        defaultValue: defaultState,
                    })
                    dispatch({
                        type: "REV",
                    })
                    dispatch(loadTeam(data.curTeamId))
                }
            })
            .catch((err) => {
                var curTeamId = getState().common.nav.currentTeamId
                dispatch(loadTeam(curTeamId))
            })
    }
}

export function loadTeams() {
    return (dispatch, getState) => {
        var divLen = getState().common.nav.divisions.length
        var teamId = getState().common.nav.currentTeamId
        var team = getState().common.nav.currentTeam
        if (team && divLen > 0 && teamId === team.name) {
            console.log("nav already loaded aborting")
            return
        }

        webApi
            ._get("/webapp/users/self/divisions", { sport_type: "any" })
            .then((divisions) => {
                return divisions.map((d) => {
                    d.teams = []
                    return d
                })
            })
            .then((divisions) => {
                var requests = []
                for (var i in divisions) {
                    var div = divisions[i]
                    requests.push({
                        uri: `/divisions/${div.division_id}/teams`,
                        method: "GET",
                    })
                }

                var params = {
                    requests: JSON.stringify(requests),
                }

                return webApi._post("/webapp/batch", params).then((json) => {
                    for (var i in divisions) {
                        divisions[i].teams = json[i].data
                        divisions[i].myTeams = []
                    }
                    divisions.push({
                        is_owner: false,
                        division_id: -1,
                        title: "Other",
                        teams: [],
                        myTeams: [],
                    })
                    return divisions
                })
            })
            .then((divisions) => {
                return webApi
                    ._get("/webapp/users/self/teams", { sport_type: "any" })
                    .then((teams) => {
                        for (var t in teams) {
                            var team = teams[t]
                            var matched = false
                            for (var d in divisions) {
                                var div = divisions[d]
                                for (var dt in div.teams) {
                                    if (
                                        div.teams[dt].team_id === team.team_id
                                    ) {
                                        divisions[d].myTeams.push(team)
                                        matched = true
                                        break
                                    }
                                }
                            }
                            if (!matched) {
                                divisions[divisions.length - 1].myTeams.push(
                                    team
                                )
                            }
                        }
                        return divisions
                    })
            })
            .then((divisions) => {
                var isUserCoach = false
                var curTeam = null
                var curTeamId = getState().common.nav.currentTeamId
                if (teamId && teamId !== "expelliarmus") {
                    localForage.setItem("current_team_id", teamId)
                }
                for (var i in divisions) {
                    var div = divisions[i]
                    for (var t in div.myTeams) {
                        var tm = div.myTeams[t]
                        if (tm.team_id === curTeamId) {
                            curTeam = tm
                        }
                        if (tm.name === curTeamId) {
                            curTeam = tm
                        }
                        if (tm.has_admin_access === true) {
                            isUserCoach = true
                        }
                    }
                }

                divisions = divisions.filter((div) => {
                    return div.myTeams.length > 0
                })

                return {
                    divisions,
                    curTeam,
                    curTeamId,
                    isUserCoach,
                }
            })
            .then((data) => {
                if (
                    data.curTeam &&
                    data.curTeam.team_id &&
                    data.curTeam.access_password
                ) {
                    // cache last used current team
                    if (data.curTeam.name !== "expelliarmus") {
                        localForage.setItem(
                            "current_team_id",
                            data.curTeam.name
                        )
                    }

                    webApi
                        .login(
                            data.curTeam.team_id,
                            data.curTeam.access_password
                        )
                        .then((success) => {
                            dispatch({
                                type: "COMMON_SET",
                                value: {
                                    currentTeam: data.curTeam,
                                    divisions: data.divisions,
                                    isUserCoach: data.isUserCoach,
                                    divisionsDidLoad: true,
                                    isTeamLoggedIn: true,
                                },
                                key: "nav",
                                defaultValue: defaultState,
                            })
                            dispatch({
                                type: "TeamAuthUpdate",
                                state: {
                                    isLoggedIn: true,
                                    error: null,
                                    teamId: data.curTeam.team_id,
                                    teamName: data.curTeam.name,
                                    team: data.curTeam,
                                    loaded: true,
                                },
                            })
                            dispatch({
                                type: "REV",
                            })
                        })
                        .catch((err) => {
                            dispatch({
                                type: "COMMON_SET",
                                value: {
                                    currentTeam: data.curTeam,
                                    divisions: data.divisions,
                                    isUserCoach: false,
                                    divisionsDidLoad: true,
                                    isTeamLoggedIn: false,
                                },
                                key: "nav",
                                defaultValue: defaultState,
                            })
                            dispatch({
                                type: "REV",
                            })
                        })
                } else {
                    var values = {
                        divisions: data.divisions,
                        divisionsDidLoad: true,
                        isTeamLoggedIn: false,
                    }
                    if (data.curTeam) {
                        values.currentTeam = data.curTeam
                        values.isUserCoach = false
                    }
                    dispatch({
                        type: "COMMON_SET",
                        value: values,
                        key: "nav",
                        defaultValue: defaultState,
                    })
                    dispatch({
                        type: "REV",
                    })
                    dispatch(loadTeam(data.curTeamId))
                }
            })
            .catch((err) => {
                console.error("modules.navigation.actions.loadTeams ERROR", err)
                var curTeamId = getState().common.nav.currentTeamId
                dispatch(loadTeam(curTeamId))
            })
    }
}

export function loadTeam(teamId) {
    return (dispatch) => {
        // abort if using global login team id
        if (teamId === "expelliarmus") {
            dispatch({
                type: "REV",
            })
            return
        }
        if (teamId === "") {
            dispatch({
                type: "COMMON_SET",
                value: {
                    currentTeam: null,
                    isTeamLoggedIn: null,
                    loaded: null,
                },
                key: "nav",
                defaultValue: defaultState,
            })
            dispatch({
                type: "REV",
            })
            return
        }

        webApi
            ._get(`/webapp/teams/${teamId}`, { sport_type: "any" })
            .then((json) => {
                // cache last used current team
                if (teamId && teamId !== "undefined") {
                    localForage.setItem("current_team_id", teamId)
                }

                dispatch({
                    type: "COMMON_SET",
                    value: {
                        currentTeam: json,
                        isTeamLoggedIn: false,
                        loaded: true,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })
                dispatch({
                    type: "REV",
                })
            })
            .catch((err) => {
                console.log("loadTeam", err)
                dispatch({
                    type: "COMMON_SET",
                    value: {
                        currentTeam: null,
                        isTeamLoggedIn: null,
                        loaded: true,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })
                dispatch({
                    type: "REV",
                })
            })
    }
}

export function selectTeam(team, cb) {
    return (dispatch) => {
        webApi.login(team.team_id, team.access_password).then((success) => {
            if (cb) {
                cb(success)
            }
            dispatch({
                type: "REV",
            })
        })
    }
}
